export interface Service {
  /** Editorial index shown alongside the title, e.g. "01". */
  number: string;
  title: string;
  description: string;
  /** Supporting evidence of capability — never the headline offering. */
  capabilities: string[];
}

export const services: Service[] = [
  {
    number: '01',
    title: 'Control, Autonomy & Estimation',
    description:
      'Control, estimation and decision-making for systems that must operate accurately in uncertain and demanding environments.',
    capabilities: [
      'Guidance, navigation and control', 'State estimation and sensor fusion',
      'Robust and multivariable control', 'Autonomy', 'Fault detection and recovery',
    ],
  },
  {
    number: '02',
    title: 'High-Reliability Software & Firmware',
    description:
      'Software across the engineering stack — from device-level firmware and embedded platforms to distributed supervisory applications.',
    capabilities: [
      'Firmware and real-time systems', 'Embedded Linux', 'Drivers and board support',
      'Supervisory and control software', 'Distributed services and APIs',
      'Automated quality and testing',
    ],
  },
  {
    number: '03',
    title: 'Modelling, Simulation & Verification',
    description:
      'Models and test environments that reveal system behaviour, verify performance and reduce deployment risk.',
    capabilities: [
      'Dynamic system modelling', 'Mission and operational analysis',
      'System identification', 'Hardware- and software-in-the-loop',
      'Performance assessment', 'Algorithm verification',
    ],
  },
  {
    number: '04',
    title: 'Systems Architecture & Integration',
    description:
      'Architectures and interfaces that bring hardware, software, communications and infrastructure into a reliable whole.',
    capabilities: [
      'System and interface architecture', 'Distributed systems',
      'Hardware-software integration', 'Device communications',
      'Redundant and fail-safe design', 'Integration environments',
    ],
  },
  {
    number: '05',
    title: 'Data & Operational Systems',
    description:
      'Systems that acquire, transport and visualise data while enabling operators to monitor and control complex equipment.',
    capabilities: [
      'Telemetry and command', 'Data acquisition and pipelines',
      'Monitoring and visualisation', 'Mission and facility operations',
      'Scientific control infrastructure', 'Edge and cloud deployment',
    ],
  },
];
